import RechargeButton from 'components/ManageBalanceButtons/RechargeButton.component';
import WithdrawButton from 'components/ManageBalanceButtons/WithdrawButton.component';
import { DropdownBonusCardAmountAvailable } from 'pages/bonus/partials/BonusAmountAvailable/BonusAmountAvailableDropdown.component';
import { Translate } from 'react-localize-redux';
import { idTracingMap } from 'utils/config.config';
import {
  BonusComponent,
  DropdownTitle,
  Panel,
  Separator,
  TransactionsRow,
  WalletRow,
} from '../style/SignedInUserToolbar.style';
import PendingSessionsBlock from './PendingSessionsBlock.component';

type WalletDropdownPanelProps = {
  onClose: () => void;
  formattedBalance: string;
  formattedBonus: string;
};

export function WalletDropdownPanel({
  formattedBalance,
  onClose,
}: WalletDropdownPanelProps) {
  return (
    <Panel>
      <PendingSessionsBlock onClose={onClose} />

      <WalletRow>
        <DropdownTitle>
          <Translate id="lbl.navbar.balance" />
        </DropdownTitle>
        <DropdownTitle style={{ marginLeft: 'auto' }}>
          {formattedBalance}
        </DropdownTitle>
      </WalletRow>

      <TransactionsRow>
        <WithdrawButton
          id={idTracingMap.CardRechargeWithdrawComponent.Withdraw}
        />
        <Separator />
        <RechargeButton
          id={idTracingMap.CardRechargeWithdrawComponent.Recharge}
        />
      </TransactionsRow>

      <BonusComponent>
        <DropdownBonusCardAmountAvailable onClose={onClose} />
      </BonusComponent>
    </Panel>
  );
}
